import r from"./function-uncurry-this.js";var a=r,i=a([].slice);export{i as default};
